/** @jsx jsx */

import {
  Children,
  Fragment as _,
  useState,
  memo,
  cloneElement,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import PDF from 'components/lib/PDF';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableBtn from 'components/lib/EditableBtn';
import SubmitBtn from './SubmitBtn';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Media from 'components/lib/Media';
import Embed from 'components/lib/Embed';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import IELayout from 'components/Layouts/IELayout';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Media_default from 'assets/Rectangle.png';
import TextEntry from './TextEntry';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children }) => {
    return children?.[0] || null;
  },
  TextEntry,
  FeedbackNonScoring: (props) => {
    const { onClose, children } = props;

    const [img, txt, btn] = children;
    return (
      <div
        css={css({
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
        })}
      >
        <div>{img}</div>

        <div
          css={css({
            margin: '20px 0',
          })}
        >
          {txt}
        </div>

        <div
          css={css({
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          })}
          onClick={onClose}
        >
          {btn}
        </div>
      </div>
    );
  },
  Feedback,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Attempt: ({ children, ...props }) => children,
  Image: ({ children, ...props }) => {
    const updatedProps = {
      ...props,
    };

    if (!props.src) {
      updatedProps.placeholder = Media_default;
    }

    return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;
    //
  },
  ColumnImageAndText: ({ children }) => {
    const interactionContext = useContext(InteractionContext);
    const { showFeedback, props } = interactionContext;
    const { useMediaInColumn = true } = props;

    if (showFeedback) {
      return null;
    }

    const [img, txt] = children;

    return (
      <div>
        <div>{img}</div>
        <div style={{ margin: '20px 0' }}>{txt}</div>
      </div>
    );
    return useMediaInColumn ? children : txt;
  },
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: SubmitBtn,
  Video,
  Audio,
  SVG,
  PDF,
  OpenPDF,
  Media,
  Embed,
  Transcript: ({ children }) => children,
  ...IELayout(InteractionContext),
};

const TextEntryDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const [showFeedback, setShowFeedback] = useState<boolean>(false);

  const renderedBlock = (interactionBlock.children as Block[]).map((child) => {
    return renderBlock(child, Components);
  });

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
          showFeedback,
          setShowFeedback($: boolean) {
            setShowFeedback($);
          },
        }}
      >
        {renderedBlock}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default TextEntryDisplay;
